<template>

    <div class="container card p-5 shadow m-auto">
        
        <h1>Edit Step for Category {{currentCategory.title}}</h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Title</span>
                </div>
                <input v-model="categoryStep.title" type="text" class="form-control" placeholder="Enter Title">
            </div>

            <div class="form-group">
                <div class="input-group-prepend w-100">
                    <span class="input-group-text w-100">{{$t("HELP")}}</span>
                </div>
                <html-editor v-model="categoryStep.help"></html-editor>
            </div>
            <div class="form-group">
                <div class="input-group-prepend w-100">
                    <span class="input-group-text w-100">{{$t("INFO_CONTENT")}}</span>
                </div>
                <html-editor v-model="categoryStep.infoContent"></html-editor>
                
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" for="inputGroupSelect01">{{$t('TYPE')}}</span>
                </div>
                <select class="custom-select" v-model="categoryStep.treatment" id="inputGroupSelect01">
                    <option value="false">{{$t('NORMAL')}}</option>
                    <option value="true">{{$t('TREATMENT')}}</option>
                </select>
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" for="inputGroupSelect02">{{$t('IS_LAST')}}</span>
                </div>
                <select class="custom-select" v-model="categoryStep.isLast" id="inputGroupSelect02">
                    <option value="true">{{$t('TRUE')}}</option>
                    <option value="false">{{$t('FALSE')}}</option>
                </select>
            </div>
            <button @click="editCategoryStep" type="button" class="btn btn-primary mb-3 d-block w-auto">{{$t("EDIT_CATEGORY_STEP")}}</button>
        </div>
    </div>

</template>

<script>
import HtmlEditor from './../../misc/HtmlEditor';

export default {
    data() {
        return {
            currentCategory: {},
            categoryStep: {
                title: null,
                help: null,
                infoContent: null,
                treatment: false,
                isLast: false,
                id: null
            },
            response: {},
        }
    },
    components: {
        HtmlEditor
    },
    methods: {
        editCategoryStep: function(){
            
            let self = this;
            this.$http.put('/api/category-steps/edit/', this.categoryStep)
            .then(response => {
                self.response = response.data;
            })
            .catch(error => {
                console.log(error);
            })
            
        },
        loadCurrentCategoryStep: function() {
            let self = this;
            this.$http.get('/api/category-steps/get/' + this.$route.params.stepId)
            .then(response => {
                self.categoryStep = response.data;
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
        loadCurrentCategory: function() {
            let self = this;
            this.$http.get('/api/categories/get/' + this.$route.params.categoryId)
            .then(response => {
                self.currentCategory = response.data;
                
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
    },
    mounted: function() {
        this.categoryStep.id = this.$route.params.stepId;
        this.loadCurrentCategory();
        this.loadCurrentCategoryStep();
    },
    watch: {
        response: function(val){
            if(val.success === true){
                setTimeout(() => {
                    this.$router.push(`/admin/categories/${this.$route.params.categoryId}/steps/`);
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000) 
        },
    }
    
}
</script>

<style scoped lang="scss">

</style>